import { timeFormatterFromMilliseconds, titleize } from "helpers/sf_utils"
import React, { useRef } from "react"
import { useEffect, useState } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import PlayerAnalytics from "./PlayerAnalytics"
import PlayerOptions from "./PlayerOptions"
import CallStats from "./CallStats"
import TranscriptionHeader from "./TranscriptionHeader"
import _ from "lodash"
// import { sample_transcriptions } from "../SampleTranscriptions/sample_transcriptions"
import { PRODUCT_TYPE_IDS, REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants"
import useFeatureFlags from "hooks/useFeatureFlags"
import { AppConfiguration } from "config"
import { WHITE_LABELED_PRODUCT_NAMES } from "config"
import { nonAlphanumericStringMatcher, whitespaceFollowedByPunctuation } from "common/utils/data_validations"

// const randomIndex = Math.floor(Math.random() * sample_transcriptions.length)
function CallTranscriptView({ call_data, call_transcriptions }) {
  const [activeAgentSentence, setActiveAgentSentence] = useState("")
  const [activeCustomerSentence, setActiveCustomerSentence] = useState("")
  const [currentPosition, setCurrentPosition] = useState(0)
  const [scrolledTime, setScrolledTime] = useState(null)
  const [transcriptScrolling, setTranscriptScrolling] = useState(false)
  const [seekBarStickPosition, setSeekBarStickPosition] = useState(0)
  const [searchTerm, setSearchTerm] = useState("")
  const [showUpcomingBar, setShowUpcomingBar] = useState(false)
  const [upcomingBarPosition, setUpcomingBarPosition] = useState(0)
  const audioRef = useRef(null)

  const [isFeatureFlagActive] = useFeatureFlags()

  const PARTICIPANT = {
    AGENT: "AGENT",
    CUSTOMER: "CUSTOMER"
  }

  let audio = null
  let transcription_sample = null
  // if (
  //   isFeatureFlagActive(
  //     REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_RANDOM_CALL_TRANSCRIPTIONS
  //   )
  // ) {
  //   const randomObject = sample_transcriptions[randomIndex]
  //   audio = randomObject[Object.keys(randomObject)[0]][0].audio
  //   transcription_sample =
  //     randomObject[Object.keys(randomObject)[0]][1].transcription
  // } else {
  const productType = call_data?.[0]?.product_type_id
  if (productType == PRODUCT_TYPE_IDS.QUOTE_FUNNELS) {
    audio = call_data?.[0]?.qf_quote_call?.recording_url
  }
  else {
    audio = call_data?.[0]?.quote_call?.recording_url
  }
  transcription_sample = call_transcriptions?.data
  // }

  const sorted_sentences =
    _.flatten(
      transcription_sample.Transcript?.map(sentence => {
        let prevWordBeginOffsetMillis = 0
        let prevWordEndOffsetMillis = 0
        return sentence.Items.map(word_obj => {
          let BeginOffsetMillis = word_obj.BeginOffsetMillis
          let EndOffsetMillis = word_obj.EndOffsetMillis
          if (BeginOffsetMillis == null) {
            BeginOffsetMillis = prevWordBeginOffsetMillis
          }
          if (EndOffsetMillis == null) {
            EndOffsetMillis = prevWordEndOffsetMillis
          }
          prevWordBeginOffsetMillis = BeginOffsetMillis
          prevWordEndOffsetMillis = EndOffsetMillis
          return {
            ...word_obj,
            BeginOffsetMillis: BeginOffsetMillis,
            EndOffsetMillis: EndOffsetMillis,
            Sentiment: sentence.Sentiment,
            ParticipantRole: sentence.ParticipantRole,
          }
        })
      })
    )

  const sentences = [];
  if (sorted_sentences.length > 0) {
    let sentence = sorted_sentences[0]["Content"] + " "
    let items = [sorted_sentences[0]]
    for (let i = 1; i < sorted_sentences.length; i++) {
      let participant = sorted_sentences[i - 1]["ParticipantRole"]
      if (participant === sorted_sentences[i]["ParticipantRole"]) {
        sentence += sorted_sentences[i]["Content"] + " "
        items.push(sorted_sentences[i])
      } else {
        if (sentence.length) {
          sentences.push({
            Content: sentence,
            ParticipantRole: participant,
            BeginOffsetMillis: items[0] ? items[0]["BeginOffsetMillis"] : 0,
            EndOffsetMillis: items[items.length - 1]
              ? items[items.length - 1]["EndOffsetMillis"]
              : 0,
            Items: items,
          })
          sentence = sorted_sentences[i]["Content"] + " "
          items = [sorted_sentences[i]]
        }
      }
    }
    //Following condition pushes the final entry to the sentences array
    if (sentence.length) {
      sentences.push({
        Content: sentence,
        ParticipantRole: sorted_sentences[sorted_sentences.length - 1]["ParticipantRole"],
        BeginOffsetMillis: items[0] ? items[0]["BeginOffsetMillis"] : 0,
        EndOffsetMillis: items[items.length - 1]
          ? items[items.length - 1]["EndOffsetMillis"]
          : 0,
        Items: items,
      });
    }
  }

  const MatchedDetails = transcription_sample?.Categories?.MatchedDetails
  let topics = []
  if (MatchedDetails) {
    topics = Object.keys(MatchedDetails)?.flatMap(topicName => {
      return MatchedDetails[topicName]?.PointsOfInterest?.map(point => {
        return {
          topicName: topicName,
          BeginOffsetMillis: point.BeginOffsetMillis,
          EndOffsetMillis: point.EndOffsetMillis,
        }
      })
    })
  }

  // Sort the topic array by the BeginOffsetMillis property
  topics.sort((a, b) => a.BeginOffsetMillis - b.BeginOffsetMillis)

  const handleSearch = event => {
    const searchValue = event.target.value
    setSearchTerm(searchValue)
  }

  //starting and ending time of each sentence for each speaker
  const AllParticipantTimestamps = []
  const AllParticipantNames = []
  //If there are 3 speakers then totalMillisecondsForEachSpeaker will have 3 elements
  const totalMillisecondsForEachSpeaker = []

  //Random colors for each speaker
  const colors = [
    "#E73989", // sfPink
    "#0074D9", // Blue
    "#85144b", // Maroon
    "#B10DC9", // Purple
    "#2ECC40", // Green
    "#FF851B", // Orange
    "#FFDC00", // Yellow
    "#FF4136", // Pink
    "#7FDBFF", // Cyan
  ]

  //Populating AllParticipantTimestamps and AllParticipantNames
  transcription_sample?.Participants?.forEach(participant => {
    AllParticipantNames.push(participant.ParticipantRole)
    const participantTimestamps = []
    sentences?.forEach(sentence => {
      const timestamps = []
      if (sentence?.ParticipantRole === participant?.ParticipantRole) {
        timestamps.push(sentence.BeginOffsetMillis)
        timestamps.push(sentence.EndOffsetMillis)
        participantTimestamps.push(timestamps)
      }
    })
    AllParticipantTimestamps.push(participantTimestamps)
  })

  //Populating totalMillisecondsForEachSpeaker
  AllParticipantTimestamps?.forEach(participantTimestamps => {
    if (participantTimestamps?.length > 0) {
      totalMillisecondsForEachSpeaker.push(
        participantTimestamps[participantTimestamps.length - 1][1]
      )
    }
  })

  let TotalConversationDurationMillis = 0
  if (
    isFeatureFlagActive(
      REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_RANDOM_CALL_TRANSCRIPTIONS
    )
  ) {
    TotalConversationDurationMillis = AllParticipantTimestamps.map(
      participantTimestamps => {
        return participantTimestamps[participantTimestamps.length - 1][1]
      }
    ).reduce((a, b) => {
      return Math.max(a, b)
    })
  } else {
    if (productType == PRODUCT_TYPE_IDS.QUOTE_FUNNELS) {
      TotalConversationDurationMillis =
        call_data[0]?.qf_quote_call?.call_duration * 1000
    }
    else {
      TotalConversationDurationMillis =
        call_data[0]?.quote_call?.call_duration * 1000
    }
  }

  //Total duration of the call, seconds, minutes here does not depict all seconds/minutes of the call, it depicts the seconds/minutes after converting into minutes/hours
  const total_call_duration = {
    total_call_duration_milliseconds: TotalConversationDurationMillis,
    total_call_duration_seconds: parseInt(
      (TotalConversationDurationMillis / 1000) % 60
    ),
    total_call_duration_minutes: parseInt(
      (TotalConversationDurationMillis / 1000 / 60) % 60
    ),
    total_call_duration_hours: parseInt(
      TotalConversationDurationMillis / 1000 / 60 / 60
    ),
  }

  //duration of the call that was covered by the transcription or by the player
  const [converedCallDuration, setCoveredCallDuration] = useState({
    covered_call_duration_milliseconds: 0,
    covered_call_duration_seconds: 0,
    covered_call_duration_minutes: 0,
    covered_call_duration_hours: 0,
  })

  const handleScroll = (timeInMillis, activeAgentSentence = null) => {
    setActiveAgentSentence(activeAgentSentence)
    setActiveCustomerSentence(null)
    setScrolledTime(parseInt(timeInMillis / 1000))
  }

  const handleCustomerScroll = (timeInMillis, activeCustomerSentence = null) => {
    setActiveCustomerSentence(activeCustomerSentence)
    setActiveAgentSentence(null)
    setScrolledTime(parseInt(timeInMillis / 1000))
  }

  const handleMouseEnter = () => {
    setTranscriptScrolling(true)
  }

  const handleMouseOut = () => {
    setTranscriptScrolling(false)
  }

  //when I move slider then transcript should scroll to the sentence that is being spoken
  useEffect(() => {
    const element = document.querySelector(".transcription-scrolled-percentage")
    if (!element || currentPosition > 100 || currentPosition < 0) {
      return
    }
    const index = sentences?.findIndex(obj => obj?.Content === activeAgentSentence || obj?.Content === activeCustomerSentence)
    const { scrollHeight } = element
    const scrolledHeight =
      (scrollHeight * ((index * 100) / sentences.length)) / 100
    element.scrollTo(0, scrolledHeight - 50) //putting 50 so that sentences don't go out of the screen from above
  }, [currentPosition])

  useEffect(() => {
    //Identify which sentence is currently being spoken
    sentences?.forEach(sentence => {
      if (
        sentence?.BeginOffsetMillis <=
        converedCallDuration?.covered_call_duration_milliseconds &&
        sentence?.EndOffsetMillis >=
        converedCallDuration?.covered_call_duration_milliseconds
      ) {
        if (sentence?.ParticipantRole == PARTICIPANT.AGENT) {
          setActiveAgentSentence(sentence?.Content)
        } else {
          setActiveCustomerSentence(sentence?.Content)
        }
      }
    })
  }, [converedCallDuration])

  return (
    <Row>
      <Col xl={3}>
        <CallStats
          transcription_sample={transcription_sample}
          totalCallDuration={total_call_duration}
          AllParticipantNames={AllParticipantNames}
          colors={colors}
          topics={topics}
          call_data={call_data}
        />
      </Col>

      <Col xl={9}>
        <Card>
          <CardBody>
            <PlayerOptions
              total_call_duration={total_call_duration}
              coveredCallDuration={converedCallDuration}
              setCoveredCallDuration={setCoveredCallDuration}
              setCurrentPosition={setCurrentPosition}
              audioRef={audioRef}
              scrolledTime={scrolledTime}
              setScrolledTime={setScrolledTime}
              transcriptScrolling={transcriptScrolling}
              setSeekBarStickPosition={setSeekBarStickPosition}
              seekBarStickPosition={seekBarStickPosition}
              showUpcomingBar={showUpcomingBar}
              upcomingBarPosition={upcomingBarPosition}
              audio={audio}
            />
            <PlayerAnalytics
              AllParticipantNames={AllParticipantNames}
              totalMillisecondsForEachSpeaker={totalMillisecondsForEachSpeaker}
              AllParticipantTimestamps={AllParticipantTimestamps}
              coveredCallDuration={converedCallDuration}
              totalCallDuration={total_call_duration}
              handleScroll={handleScroll}
              showUpcomingBar={showUpcomingBar}
              setShowUpcomingBar={setShowUpcomingBar}
              setUpcomingBarPosition={setUpcomingBarPosition}
              sentences={sentences}
              colors={colors.map((color, c_index) => !c_index && AppConfiguration?.PRODUCT_NAME !== WHITE_LABELED_PRODUCT_NAMES.INSURANCE_IO ? AppConfiguration?.PRODUCT_FAV_COLOR : color)}
              topics={topics}
            />
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <TranscriptionHeader value={searchTerm} onChange={handleSearch} />
            <Row
              style={{ height: "100vh", overflowY: "scroll" }}
              onMouseOver={handleMouseEnter}
              onMouseOut={handleMouseOut}
              className="transcription-scrolled-percentage mt-3 ps-1"
            >
              {sentences.map((sentence, index) => {
                const words = sentence["Items"]
                return (
                  <div className="d-flex align-items-top mb-2" key={index}>
                    <Col
                      style={{
                        fontWeight: `${activeAgentSentence == sentence["Content"] || activeCustomerSentence == sentence["Content"] ? 600 : 400
                          }`,
                      }}
                      className="w-120"
                      sm="2"
                    >
                      {titleize(sentence["ParticipantRole"])}
                    </Col>
                    <Col
                      sm="1"
                      style={{ color: "#929292" }}
                      className="text-dark fs-11"
                    >
                      {timeFormatterFromMilliseconds(
                        sentence["BeginOffsetMillis"]
                      )}
                    </Col>
                    <Col sm="9">
                      {
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            sentence["ParticipantRole"] == PARTICIPANT.AGENT ?
                              handleScroll(
                                sentence["BeginOffsetMillis"],
                                sentence["Content"]
                              ) : handleCustomerScroll(sentence["BeginOffsetMillis"],
                                sentence["Content"])
                          }
                          }
                        >
                          {searchTerm !== "" ? (
                            <span>
                              {(sentence["Content"] === activeAgentSentence || sentence["Content"] === activeCustomerSentence)
                                ? words.map((word, index) => {
                                  let currentPosition = -1
                                  for (let i = 0; i < words.length; i++) {
                                    const word = words[i]
                                    if (
                                      word["EndOffsetMillis"] >=
                                      converedCallDuration.covered_call_duration_milliseconds
                                    ) {
                                      currentPosition = i
                                      break
                                    }
                                  }
                                  const shouldAgentHighlight =
                                    index <= currentPosition &&
                                    activeAgentSentence === sentence["Content"] && sentence["ParticipantRole"] == PARTICIPANT.AGENT
                                  const shouldCustomerHighlight =
                                    index <= currentPosition &&
                                    activeCustomerSentence === sentence["Content"] && sentence["ParticipantRole"] == PARTICIPANT.CUSTOMER
                                  return (
                                    <span
                                      key={index}
                                      style={{
                                        backgroundColor: shouldAgentHighlight
                                          ? "#f5c9dd" : shouldCustomerHighlight ? "#D4ECFA"
                                            : "transparent",
                                      }}
                                    >
                                      {index !== words.length - 1 &&
                                        nonAlphanumericStringMatcher.test(
                                          words[index + 1]["Content"]
                                        )
                                        ? word["Content"]
                                        : word["Content"] + " "}
                                    </span>
                                  )
                                })
                                : sentence["Content"].replace(whitespaceFollowedByPunctuation, (_match, p1) => p1)
                                  .split(new RegExp(`(${searchTerm})`, "i"))
                                  .map((part, i) => {
                                    return (
                                      <React.Fragment key={i}>
                                        {part.toLowerCase() ===
                                          searchTerm.toLowerCase() && (
                                            <span
                                              style={{
                                                backgroundColor: "yellow",
                                              }}
                                            >
                                              {part}
                                            </span>
                                          )}
                                        {part.toLowerCase() !==
                                          searchTerm.toLowerCase() && part}
                                      </React.Fragment>
                                    )
                                  })}
                            </span>
                          ) : (
                            words.map((word, index) => {
                              let currentPosition = -1
                              for (let i = 0; i < words.length; i++) {
                                const word = words[i]
                                if (
                                  word["EndOffsetMillis"] >=
                                  converedCallDuration.covered_call_duration_milliseconds
                                ) {
                                  currentPosition = i
                                  break
                                }
                              }
                              const shouldAgentHighlight =
                                index <= currentPosition &&
                                activeAgentSentence === sentence["Content"] && sentence["ParticipantRole"] == PARTICIPANT.AGENT
                              const shouldCustomerHighlight =
                                index <= currentPosition &&
                                activeCustomerSentence === sentence["Content"] && sentence["ParticipantRole"] == PARTICIPANT.CUSTOMER
                              return (
                                <span
                                  key={index}
                                  style={{
                                    backgroundColor: shouldAgentHighlight
                                      ? "#f5c9dd" : shouldCustomerHighlight ? "#D4ECFA"
                                        : "transparent",
                                  }}
                                >
                                  {index !== words.length - 1 &&
                                    nonAlphanumericStringMatcher.test(words[index + 1]["Content"])
                                    ? word["Content"]
                                    : word["Content"] + " "}
                                </span>
                              )
                            })
                          )}
                        </div>
                      }
                    </Col>
                  </div>
                )
              })}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default CallTranscriptView
